function Header() {
    return (<div className="container" style={{padding: '144px 0 64px'}}>
        <h2>Membership Pricing</h2>
        <p className="par-title-head">Experience all the benefits of language immersion, without having to pay for international travel fees.</p>
    </div>)
}

export default Header;